import React from 'react';
import { Link } from 'react-router-dom';

export const MarketingFooter = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">D</span>
              </div>
              <span className="ml-2 text-xl font-bold">DICOMITY</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Soluciones de interoperabilidad para instituciones de salud:
              DICOMFiles y DICOMCapture conectan imágenes médicas, equipos y
              sistemas clínicos en un flujo digital más ágil.
            </p>
            <div className="text-sm text-gray-400">
              <p>© 2024 DICOMITY. Todos los derechos reservados.</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/documentation" className="text-gray-400 hover:text-white transition-colors">
                  Documentación
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-2 text-gray-400">
              <p>Email: info@dicomity.com.ar</p>
              <p>Buenos Aires, Argentina</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
